"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const Integration_1 = require("../../Integration");
let CampaignMonitorInput = class CampaignMonitorInput extends Integration_1.IntegrationInput {
};
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    class_validator_1.ValidateIf((o) => !!o.campaignMonitorClientName),
    class_validator_1.MinLength(1, { message: 'Required' }),
    tslib_1.__metadata("design:type", String)
], CampaignMonitorInput.prototype, "campaignMonitorClientName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    class_validator_1.ValidateIf((o) => !!o.campaignMonitorClientId),
    class_validator_1.MinLength(1, { message: 'Required' }),
    tslib_1.__metadata("design:type", String)
], CampaignMonitorInput.prototype, "campaignMonitorClientId", void 0);
CampaignMonitorInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], CampaignMonitorInput);
exports.CampaignMonitorInput = CampaignMonitorInput;
//# sourceMappingURL=index.js.map